import { page, track as track$1 } from '@zillow/universal-analytics';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Although we don't think of objects as being ordered, and order doesn't play a role in equality of objects, they do in
 * fact order their properties. And this order generally gets preserved when objects are serialized (e.g., to JSON).
 *
 * This function returns a shallow copy of the input object, except the properties are sorted using the keys.
 */
var sortObject = function sortObject(object) {
  var result = {};
  Object.keys(object).sort().forEach(function (key) {
    result[key] = object[key];
  });
  return result;
};
/**
 * This function returns a shallow copy of the input object, except any properties with a value of undefined are
 * excluded.
 */

var removeUndefinedProperties = function removeUndefinedProperties(object) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = object[key];

    if (value !== undefined) {
      result[key] = object[key];
    }
  });
  return result;
};

var GA_PREFIX = 'ga_';
var state = {
  cdpTreatment: 'CONTROL',
  serviceName: undefined
};
var setCdpTreatment = function setCdpTreatment(cdpTreatment) {
  state.cdpTreatment = cdpTreatment;
};
/**
 * The service name identifies the static bundle in which this package is installed. For example, the ZO landing page
 * and questionnaire are both part of the static-zo-growth static bundle, so they would use 'static-zo-growth'.
 */

var getServiceName = function getServiceName() {
  return state.serviceName;
};
var setServiceName = function setServiceName(serviceName) {
  state.serviceName = serviceName;
};

/**
 * Tealium specs support optional properties, but we currently aren't making use of that functionality. That is to say,
 * every known property is required. So even though there are effectively-optional properties--that is to say,
 * properties that we know are really meant to be optional--we're still forced to provide values for those properties.
 * For such properties, we've been asked to pass the empty string when there's no value, and this is where we specify
 * the defaults. These defaults are kept separate from the rest of the defaults so we can easily remove them if we begin
 * making use of optional properties in the Tealium specs, or if we switch to another CDP vendor in the future.
 *
 * NOTE: We intentionally provide no defaults for 'action', 'brand', 'cdp_event', 'lob', or 'process', since every event
 * we've seen has specified values for these. It would be a legitimate problem if any of these were missing, and we
 * would want spec violations to get someone's attention.
 *
 * NOTE: Each spec has its own set of properties. E.g., spec 1 might have property a and b, and spec 2 might have
 * properties a and c. Properties b and c might both be effectively optional, but we still have to pass in an empty
 * value. For events matching spec 1, we don't have to include c though since it's not mentioned in the spec. Same for
 * spec 2--you don't have to include b. However, to keep this defaulting logic simple, we don't break it down by spec.
 * For events matching spec 1, we'll include c anyway. And for events matching spec 2, we'll include b anyway. The
 * effect of this is that the following set of defaults is the union of all specs' sets of effectively-optional
 * properties. That is, for any property that should be made optional in some spec (but isn't currently since we don't
 * use optional properties in Tealium specs), it will appear here, mapped to some empty default.
 */

var TEALIUM_EVENT_DEFAULTS = {
  content: '',
  content_campaign: '',
  content_index: '',
  content_version: '',
  event_version: '',
  lob_email: '',
  lob_phone: '',
  object: '',
  object_description: '',
  profile_email: '',
  service: '',
  source: ''
};

var EVENT_DEFAULTS = _objectSpread2({
  action_is_auto: false
}, TEALIUM_EVENT_DEFAULTS);

function event(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var typeProperties = parseTypeString(type);

  var unenrichedEvent = _objectSpread2(_objectSpread2({}, typeProperties), removeUndefinedProperties(payload));

  var enrichedEvent = createEnrichedEvent(unenrichedEvent); // Sort the event to aid testing and debugging (sorting makes the properties show up in a standard order).

  return sortObject(_objectSpread2(_objectSpread2({}, EVENT_DEFAULTS), enrichedEvent));
}

function parseTypeString(type) {
  var array = type.split('.');

  if (array.length !== 3) {
    throw new Error("Event types consist of 3 (not ".concat(array.length, ") pieces: lob, process, and action"));
  }

  var _array = _slicedToArray(array, 3),
      lob = _array[0],
      process = _array[1],
      action = _array[2];

  return {
    action: action,
    lob: lob,
    process: process
  };
}

function createEnrichedEvent(unenrichedEvent) {
  var lob = unenrichedEvent.lob,
      process = unenrichedEvent.process,
      action = unenrichedEvent.action;
  var enrichments = {};
  var cdpEventComponents = [lob, process]; // For some reason, we only include the action in cdp_event when it's 'view'.

  if (action === 'view') {
    cdpEventComponents.push(action);
  }

  enrichments.cdp_event = cdpEventComponents.join('_');
  var serviceName = getServiceName();

  if (serviceName !== undefined) {
    enrichments.service = serviceName;
  }

  if (lob === 'zo') {
    enrichments.brand = 'zillow';

    if (action !== 'view') {
      enrichments["".concat(GA_PREFIX, "category")] = 'InstantOffer';
    }
  } // Note: When we eventually adopt the "universal taxonomy", we will add logic here to build (1) ga_category from lob
  // and process, (2) ga_action from action, object, object_description, and source, and (3) ga_label from content.
  // Enrichments are included first so they can't override values included in the unenriched event.


  return _objectSpread2(_objectSpread2({}, enrichments), unenrichedEvent);
}

function track(event) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$integrations = options.integrations,
      integrations = _options$integrations === void 0 ? {} : _options$integrations,
      hitCallback = options.hitCallback;
  var gaParams = extractGaParamsFromEvent(event);

  var trackPageView = function trackPageView() {
    page(gaParams.pageURL, _objectSpread2(_objectSpread2({}, gaParams), {}, {
      custom_payload: event
    }), _objectSpread2(_objectSpread2({}, options), {}, {
      hitCallback: hitCallback,
      integrations: _objectSpread2({
        cdp: true
      }, integrations)
    }));
  };

  var trackEvent = function trackEvent() {
    track$1(_objectSpread2(_objectSpread2({}, gaParams), {}, {
      custom_payload: event
    }), _objectSpread2(_objectSpread2({}, options), {}, {
      hitCallback: hitCallback,
      integrations: _objectSpread2({
        cdp: true
      }, integrations)
    }));
  };

  return event.action === 'view' ? trackPageView() : trackEvent();
}

function extractGaParamsFromEvent(event) {
  var gaParams = {};
  Object.keys(event).forEach(function (key) {
    if (key.startsWith(GA_PREFIX)) {
      var prefixlessKey = key.substring(GA_PREFIX.length);
      gaParams[prefixlessKey] = event[key];
    }
  });
  return gaParams;
}

var _excluded = ["timeout"];

var trackAsync = function trackAsync(event) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1000 : _ref$timeout,
      restOptions = _objectWithoutProperties(_ref, _excluded);

  return new Promise(function (resolve, reject) {
    var options = _objectSpread2(_objectSpread2({}, restOptions), {}, {
      hitCallback: resolve
    });

    track(event, options);
    setTimeout(function () {
      return reject(new Error("trackAsync timed out after ".concat(timeout, " ms; the event may not") + " be sent if you don't keep waiting. Event: ".concat(JSON.stringify(event))));
    }, timeout);
  });
};

function trackGTMEvent(event) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var eventData = _objectSpread2({
    event: event
  }, meta);

  var _window = window,
      dataLayer = _window.dataLayer;

  if (dataLayer) {
    dataLayer.push(eventData);
  } else if (process.env.BUILD_ENV === 'local') {
    console.log('trackGTMEvent', eventData);
  }
}

export { event, setCdpTreatment, setServiceName, track, trackAsync, trackGTMEvent };
